import { useState } from "react";
import { listingCategories, listingCategoryLabel } from "../data/listingCategories";

function ShopDashboardPage({
  error,
  deletingListingId,
  isLoading,
  isCreatingItem,
  isGeneratingDescription,
  listings,
  onCreateItem,
  onDeleteItem,
  onGenerateDescription,
  onUpdateInventory,
  onUpdateShopCategory,
  shopCategories,
  mode = "create",
  onBack,
}) {
  const [item, setItem] = useState({
    title: "",
    description: "",
    category: "",
    shopCategory: "",
    condition: "",
    priceAmount: "",
    location: "",
    inventoryCount: "1",
  });
  const [itemImage, setItemImage] = useState([]);
  const inventoryListings = listings.filter((listing) => listing.status !== "archived");

  if (isLoading) {
    return <section className="main-panel"><div className="empty-results">Henter din butik...</div></section>;
  }

  return (
    <section className="main-panel shop-dashboard">
      <div className="page-heading">
        <div>
          <span className="mini-label">{mode === "stock" ? "Lager" : "Ny vare"}</span>
          <h1>{mode === "stock" ? "Administrer lager" : "Tilføj vare"}</h1>
          <p>{mode === "stock" ? "Se og opdater den præcise beholdning for butikkens varer." : "Opret en ny vare, som vises direkte i din butik."}</p>
        </div>
        <button className="secondary-action page-action" onClick={onBack} type="button">Tilbage til butik</button>
      </div>

      {error && <p className="status-line error">{error}</p>}

      {mode === "create" && <div className="shop-create-section">
        <div>
          <span className="mini-label">Ny vare</span>
          <h2>Opret en vare til salg</h2>
          <p>Varen publiceres direkte på markedspladsen og tilføjes til dit lager.</p>
        </div>
        <form className="shop-item-form" onSubmit={async (event) => {
          event.preventDefault();
          const form = event.currentTarget;
          const created = await onCreateItem(item, itemImage);
          if (created) {
            setItem({ title: "", description: "", category: "", shopCategory: "", condition: "", priceAmount: "", location: "", inventoryCount: "1" });
            setItemImage([]);
            form.reset();
          }
        }}>
          <label>Titel<input required value={item.title} onChange={(event) => setItem({ ...item, title: event.target.value })} placeholder="Produktnavn" /></label>
          <label>Kategori<select required value={item.category} onChange={(event) => setItem({ ...item, category: event.target.value })}>
            <option value="">Vælg kategori</option>
            {listingCategories.map((category) => (
              <option key={category} value={category}>{listingCategoryLabel(category)}</option>
            ))}
          </select></label>
          <label>Butikskategori<select value={item.shopCategory} onChange={(event) => setItem({ ...item, shopCategory: event.target.value })}><option value="">Ingen</option>{shopCategories.map((category) => <option key={category}>{category}</option>)}</select></label>
          <label>Pris (DKK)<input required type="number" min="0" value={item.priceAmount} onChange={(event) => setItem({ ...item, priceAmount: event.target.value })} /></label>
          <label>Antal på lager<input required type="number" min="0" max="1000000" value={item.inventoryCount} onChange={(event) => setItem({ ...item, inventoryCount: event.target.value })} /></label>
          <label>Stand<input value={item.condition} onChange={(event) => setItem({ ...item, condition: event.target.value })} placeholder="Ny, god, brugt..." /></label>
          <label>Lokation<input value={item.location} onChange={(event) => setItem({ ...item, location: event.target.value })} placeholder="København" /></label>
          <label className="shop-item-description">Beskrivelse<textarea rows="4" value={item.description} onChange={(event) => setItem({ ...item, description: event.target.value })} /></label>
          <label>
            Billeder
            <span className="file-upload-control">
              <input type="file" accept="image/jpeg,image/png,image/webp" multiple onChange={(event) => {
                setItemImage(Array.from(event.target.files || []));
              }} />
              <span className="secondary-action">Vælg billeder</span>
              <small>{itemImage.length ? `${itemImage.length} ${itemImage.length === 1 ? "billede valgt" : "billeder valgt"}` : "Ingen billeder valgt"}</small>
            </span>
          </label>
          <div className="shop-ai-action">
            <button className="secondary-action" disabled={!itemImage.length || isGeneratingDescription} onClick={async () => {
              const analysis = await onGenerateDescription(itemImage);
              if (!analysis) return;
              setItem((current) => ({
                ...current,
                title: analysis.title || current.title,
                description: analysis.description || current.description,
                category: analysis.category || current.category,
              }));
            }} type="button">{isGeneratingDescription ? "AI analyserer..." : "Hjælp mig med AI"}</button>
            <small>AI bruger op til de første tre billeder til at foreslå titel, beskrivelse og kategori. Du kan redigere alt bagefter.</small>
          </div>
          <button className="primary-action" disabled={isCreatingItem} type="submit">{isCreatingItem ? "Opretter..." : "Opret og publicer"}</button>
        </form>
      </div>}

      {mode === "stock" && <div className="inventory-section">
        <div><span className="mini-label">Lager</span><h2>Beholdning</h2></div>
        {inventoryListings.length === 0 ? <div className="empty-results">Opret en annonce for at begynde at styre lager.</div> : (
          <div className="inventory-list">
            {inventoryListings.map((listing) => (
              <article key={listing.id}>
                <div><strong>{listing.title}</strong><span>{listing.status}</span></div>
                <div className="inventory-actions">
                  <label>Butikskategori<select disabled={deletingListingId === listing.id} value={listing.shop_category || ""} onChange={(event) => onUpdateShopCategory(listing.id, event.target.value)}><option value="">Ingen</option>{shopCategories.map((category) => <option key={category}>{category}</option>)}</select></label>
                  <label>Antal<input disabled={deletingListingId === listing.id} type="number" min="0" max="1000000" value={listing.inventory_count} onChange={(event) => onUpdateInventory(listing.id, Number(event.target.value))} /></label>
                  <button className="danger-secondary" disabled={Boolean(deletingListingId)} onClick={() => onDeleteItem(listing)} type="button">
                    {deletingListingId === listing.id ? "Sletter..." : "Slet vare"}
                  </button>
                </div>
              </article>
            ))}
          </div>
        )}
      </div>}
    </section>
  );
}

export default ShopDashboardPage;
